<template>
  <div class="quick-drawer">
    <div
      class="trigger"
      :style="{ right: visible ? '330px' : 0 }"
      @click="() => (visible = !visible)"
    >
      <div v-if="!visible">
        <div>
          <a-icon type="star" style="color:#ffc53d;font-size:16px;margin-top:10px" theme="filled" />
        </div>
        <div class="tap">{{ $t('page_button_shortcut_label') }}</div>
      </div>
      <div v-if="visible">
        <div><a-icon type="close" style="color:#ffffff;font-size:18px;margin-top:20px" /></div>
        <div class="tap">{{ $t('close') }}</div>
      </div>
    </div>
    <a-drawer
      v-if="visible"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      style="width:330px"
    >
      <div class="rectangle">
        <a-icon type="exclamation-circle" theme="filled" style="color:#4a90e2;margin-right:8px;" />
        <span class="title">
          {{ $t('page_button_shortcut_label_right_side') }}"
          <a-icon type="star" style="color:#ffc53d;font-size:16px;margin-top:10px" theme="filled" />
          "{{ $t('page_button_shortcut_label_add_close') }}
        </span>
      </div>
      <a-row :gutter="24">
        <a-col
          v-for="(item, index) in drawerList"
          :key="item.app + index"
          style="cursor: pointer;margin:0 auto;"
          @click="jump(item)"
        >
          <div style="display:flex;justify-content: space-between;">
            <a>{{ item.code ? $t(item.code) : item.title }}</a>
            <div>
              <span>{{ item.code ? $t(item.code) : $t(item.name) }}</span
              >-<span>{{ $t(item.app) }}</span>
            </div>
            <div><a-icon type="right" style="color:#d8d8d8" /></div>
          </div>
          <a-divider />
        </a-col>
      </a-row>
    </a-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUserInfo } from '@/utils/auth'
import { TenantSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { mapActions } from 'vuex'
import router from '@/router'
import { TenantAppServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'

const tssp = new TenantSettingServiceProxy()
const tasp = new TenantAppServiceProxy()

export default {
  name: 'QuickDrawer',
  data() {
    return {
      visible: false,
      drawerList: [],
      appMap: []
    }
  },
  computed: {
    ...mapGetters(['drawer'])
  },
  created() {
    this.init()
  },
  watch: {
    drawer: {
      handler(val) {
        if (val.length > 0) {
          this.getUserInfo()
        }
      }
    }
  },
  methods: {
    ...mapActions({
      generateRoutes: 'permission/generateRoutes'
    }),
    onClose() {
      this.visible = false
    },
    async jump(item) {
      const data = await this.generateRoutes(item.name) // 动态增加路由
      this.$store.commit('permission/SET_ROUTES', data)
      const app = this.appMap.find((res) => res.appCode === item.name)
      if (app) {
        this.$store.commit('permission/SET_APP_ROUTE_MAP', {
          appCode: app.appCode,
          appName: app.appName,
          routes: data.length ? data[0].children : []
        })
      }
      router.addRoutes(
        data.concat({
          path: '*',
          redirect: '/404'
        })
      )
      this.$router.push(item.link)
      this.visible = false
    },
    async init() {
      const userId = this.getUserId()
      const res = await tssp.detailConditions(userId, 'location-label', '', '', '', '')
      if (res.length) {
        this.$store.commit('user/SET_DRAWER_ID', res[0].id)
        this.$store.commit('user/SET_DRAWER', JSON.parse(res[0].paramValue || '[]'))
      }
      const appList = await tasp.getCurrentTenantGrantAPPList(1)
      this.appMap = appList
    },
    getUserId() {
      const info = getUserInfo()
      return info.user_id || ''
    },
    getUserInfo() {
      this.drawerList = this.drawer
      this.drawerList.forEach((res) => {
        let arr = res.link.split('/')
        if (arr[1] === 'platform') {
          res['name'] = 'console'
        } else if (arr[1] === 'dnc') {
          res['name'] = 'dnc'
        } else if (arr[1] === 'material') {
          res['name'] = 'material'
        } else if (arr[1] === 'tpm') {
          res['name'] = 'device_management'
        } else if (arr[1] === 'qc') {
          res['name'] = 'qc'
        } else if (arr[1] === 'job') {
          res['name'] = 'coproduction'
        } else if (arr[1] === 'mdc') {
          res['name'] = 'mdc'
        } else if (arr[1] === 'ops') {
          res['name'] = 'ops'
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.trigger {
  position: absolute;
  top: 240px;
  background: #1890ff;
  width: 48px;
  height: 92px;
  // right: 256px;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  cursor: pointer;
  pointer-events: auto;
  z-index: 1001;
  text-align: center;
  font-size: 16px;
  border-radius: 4px 0 0 4px;
  transition: all 0.3s ease;

  i {
    color: rgb(255, 255, 255);
    font-size: 20px;
  }
  .tap {
    width: 28px;
    height: 44px;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #ffffff;
    margin: 6px 10px;
  }
}
.rectangle {
  width: 313px;
  height: 60px;
  background-color: #d0edff;
  border-radius: 2px;
  border: solid 1px #4a90e2;
  margin: 15px auto;
  padding: 0 8px;
}
.title {
  font-size: 14px;
  color: #4a90e2;
}
/deep/ .ant-drawer-body {
  padding: 0;
}
/deep/ .ant-drawer-content-wrapper {
  width: 330px !important;
}
/deep/ .ant-row {
  margin: 0 !important;
}
</style>
